import * as React from "react";
import { SaveButton, Toolbar } from "react-admin";

export const ActiveEditToolbar = ({ loading, isDisable, ...rest }) => {
  return (
    <Toolbar
      {...rest}
      sx={{ display: "flex", justifyContent: "space-between" }}
    >
      <SaveButton
        alwaysEnable={!isDisable && !loading}
        disabled={isDisable || loading}
      />
    </Toolbar>
  );
};

export const ActiveCreateToolbar = props => (
  <Toolbar
    {...props}
    sx={{ display: "flex", justifyContent: "space-between" }}
  >
    <SaveButton alwaysEnable />
  </Toolbar>
);
